import { render, staticRenderFns } from "./CfgEmpresa.vue?vue&type=template&id=43dbc23e&scoped=true"
import script from "./CfgEmpresa.vue?vue&type=script&lang=js"
export * from "./CfgEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbc23e",
  null
  
)

export default component.exports